$( document ).ready(function() {

	/*Filter*/
	$('#filter-open, #filter-container').click(function()
	{
		$('#filter-icons').toggleClass("filter-open-btn filter-close-btn");
	    $(".filters-size-section").toggle();
   	    $('.filter-div-open').toggle();
	});

	//product image on hover
	$('.grid-product__image-wrapper').hover(function(event) {
	        var productId =  this.id;
	        var productSizeSection = "." + productId;
	        var productImageSection = "#" + productId;

	        $(productSizeSection).show();
	        $(productImageSection).mouseleave(function(event) {
		        $(productSizeSection).hide();
		        // $('img.campaign_product_image').fadeTo('slow', 0);
       	    });
    });
	$('.voucher_code_click').click(function(){
        $('.voucher_code_block').toggle();
    });
    if ($('#admin_bar_iframe').length) {
    	$('body').addClass('iframe-on');
	}



	// $('.modal_close_btn').click(function()
	// {
	// 	console.log("close clicked");
	// 	$('#modal-content').hide();
	// 	$.cookie('the_cookie', 'the_value', { expires: 7 });
	// 	//$.cookie('the_cookie', 'the_value');
	// 	alert($.cookie('the_value'));
	// 	console.log("cookie created");
	// });

	// if (Boolean(readCookie('hide'))) {
  //               // $('.pop-up').hide();
  //               // $('.pop-up').fadeOut(1000);
  //           }
  //           $('.modal_close_btn').click(function (e) {
	// 						console.log("test close ");
  //               $('.pop-up').fadeOut(700);
  //               $('#overlay').removeClass('blur-in');
  //               $('#overlay').addClass('blur-out');
  //               e.stopPropagation();
	//
  //               createCookie('hide', true, 1)
  //               return false;
  //           });
	//
  //           function createCookie(name, value, days) {
  //               if (days == 30) {
  //                   var date = new Date();
  //                   date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  //                   var expires = "; expires=" + date.toGMTString();
  //               }
  //               else var expires2 = "";
  //               document.cookie = name + "=" + value + "; expires=" + expires + "; path=/";
	//
  //             //  $.cookie(name, value, { expires: days });
  //           }
	//
  //           function readCookie(name) {
  //               var nameEQ = name + "=";
  //               var ca = document.cookie.split(';');
  //               for (var i = 0; i < ca.length; i++) {
  //                   var c = ca[i];
  //                   while (c.charAt(0) == ' ') c = c.substring(1, c.length);
  //                   if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //               }
  //               return null;
  //           }
	//
  //           function eraseCookie(name) {
  //               createCookie(name, "", -1);
  //           }






});

// $(document).on('click', '.modal_close_btn', function () {
// 	console.log("close button clicked");
// 				$('#modal-content').hide();
//         $.cookie('the_cookie', 'the_value', { expires: 7 });
//   });

/*
/ Product page slick slider init
*/
$(function() {
   $('.product-slider__for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.product-slider__nav',
      centerMode: true,
      centerPadding: '8px',
			responsive: [
				{
						breakpoint: 769,
						settings: {
								dots: true,
								asNavFor: null,
								draggable: true
						}
				}
			]
    });

    $('.product-slider__nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: true,
      asNavFor: '.product-slider__for',
      dots: false,
      vertical: true,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
			responsive: [
					{
	            breakpoint: 1366,
	            settings: {
			            vertical: false,
									centerMode: false,
	            }
	        }]
    });

		//remove active class from all thumbnail slides
		$('.product-slider__nav .slick-slide').removeClass('slick-active');
		//set active class to first thumbnail slides
		$('.product-slider__nav .slick-slide').eq(0).addClass('slick-active');

	 	// On before slide change match active thumbnail to current slide
	 	$('.product-slider__for').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			 	var mySlideNumber = nextSlide;
			 	$('.product-slider__nav .slick-slide').removeClass('slick-active');
			 	$('.product-slider__nav .slick-slide').eq(mySlideNumber).addClass('slick-active');
		});

		//UPDATED
		$('.product-slider__for').on('afterChange', function(event, slick, currentSlide){
			  $('.content').hide();
			  $('.content[data-id=' + (currentSlide + 1) + ']').show();
		});

});

/*
/ Product page - sizing chart
*/
$( function() {
		var width = window.innerWidth;

		if ($('#tabs').length) {
            $('#tabs').tabs({
                hide: {
                    effect: "fade",
                    duration: 500
                }
            });
		}

		if (width < 768) {
			$( ".section-features__wrapper" ).accordion({
				collapsible: true
			});

			$( ".section-size__wrapper" ).accordion({
					collapsible: true,
					active: false
			});
		}
});

$(window).resize(function(){
		if (window.innerWidth < 768) {
			$( ".section-features__wrapper" ).accordion("refresh");
			$( ".section-size__wrapper" ).accordion("refresh");
		}
});

$( function() {
		$('.login-dialog').magnificPopup({
			showCloseBtn: false,
			fixedContentPos: true,
			fixedBgPos: true,
			preloader: false,
			midClick: true,
			removalDelay: 500, //delay removal by X to allow out-animation

			callbacks: {
				beforeOpen: function() {
					 	this.st.mainClass = this.st.el.attr('data-effect');
				},
				open: function() {
					 	$('.login-dialog').addClass("dialog-opened");
				},
				close: function() {
						$('.login-dialog').removeClass("dialog-opened");
				}
			}
		});
});

/*
/  Search Openers
*/

$(window).bind("load", function() {
    var width = $(window).width();
    if ((width < 1376) && (width > 1024)) {
        $(".nav-search").click(function(e) {
            e.preventDefault();
            var t = $(this).siblings("form");
            var f = $(".top-right-nav > li").not(".site-nav--search__bar");
            t.css('display', 'inline-block');
            f.hide(),
                $(this).hide(),
                $(".site-nav--search__bar .input-group-field.aa-input").focus().animate({
                    width: "150px"
                }, 300);
            //$('.header-wrapper').css('background-color','#ffffff');
        });

        $(".nav-search + form button").click(function(e) {
            var t = $(".site-nav--search__bar .input-group-field.aa-input").val();
            e.preventDefault();
            var a = $(this).parents("form");
            var f = $(".top-right-nav > li").not(".site-nav--search__bar");
            $(".site-nav--search__bar .input-group-field.aa-input").animate({
                width: "0"
            }, 300, function() {
                a.hide(),
                    $(".nav-search").css('display', 'inline-block');
                f.show();
            })
        });
    }
    else {
        $(".nav-search").click(function(e) {
            e.preventDefault();
            var t = $(this).siblings("form");
            t.css('display', 'inline-block');
            $(this).hide(),
                $(".site-nav--search__bar .input-group-field.aa-input").focus().animate({
                    width: "150px"
                }, 300)
        });

        $(".nav-search + form button").click(function(e) {
            e.preventDefault();
            var a = $(this).parents("form");
            $(".site-nav--search__bar .input-group-field.aa-input").animate({
                width: "0"
            }, 300, function() {
                a.hide(),
                    $(".nav-search").css('display', 'inline-block');
            })
        });
    }
});

/*
/  Smooth Scroll init
*/
$(window).scroll(function() {
		$('.product-single__meta').trigger('detach.ScrollToFixed');
		$('.product-single__meta').attr("style","");
});

smoothScroll.init();

/*
/   Animated header
*/

function stickyHeader() {
	 var e = $('.header-wrapper');
	 window.pageYOffset < 12 ? ($('body').addClass('promo-active'), e.addClass('transparent h-top'),
	 e.removeClass('scrolled h-white')) : ($('body').removeClass('promo-active'), e.removeClass('transparent h-top'),
	 e.addClass('scrolled h-white'));
 }

 $( document ).ready(function() {
	 	stickyHeader();

     // $('form.search-bar .input-group-field').keypress(function (e) {
     //     if (e.which == 13) {
     //         $('form.search-bar').submit();
     //         return false;
     //     }
     // });
});

$(function(){
	 $(window).scroll(function() {
		 	stickyHeader();
	 });
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
